import React, { Component } from "react";
import "../styles/style.css";
import $ from "jquery";
import * as d3 from "d3";
import axios from "axios";

export default class Bubbles extends Component {

  constructor() {
    super();
    this.state = { 
      isLoading: true, cryptoData: [] 
    };
  }
  
componentDidMount() {
  console.debug("After mount! Let's load data from API...");
  axios.get('https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd&per_page=50')
  .then(response => {
    this.setState({ cryptoData: response.data });
    this.setState({ isLoading: false });
  });
}

  render() {
    const { isLoading, cryptoData } = this.state;
    const coins = [];
    var data = [];
    var nf = new Intl.NumberFormat();

    for (let i = 0; i < cryptoData.length; i++) {
      var coin = cryptoData[i];
      var minplus = String(coin.market_cap_change_percentage_24h);
      if (minplus.includes("-")) {
        coin["color"] = "red";
      } else {
        coin["color"] = "green";
      }
      coins.push(coin);
    }
    
    coins.forEach((coin) => {
      var text = coin.symbol;
      var r = coin.market_cap / 2000000000;
      if (r < 5) {
        r = 10;
      }
      data.push({
        text: text,
        category: coin.price_change_percentage_24h + "%",
        image: coin.image,
        color: coin.color,
        r: r,
      });
    });
    
    function collide(alpha) {
      var quadtree = d3.geom.quadtree(data);
      return function (d) {
        var r = d.r + 10,
          nx1 = d.x - r,
          nx2 = d.x + r,
          ny1 = d.y - r,
          ny2 = d.y + r;
        quadtree.visit(function (quad, x1, y1, x2, y2) {
          if (quad.point && quad.point !== d) {
            var x = d.x - quad.point.x,
              y = d.y - quad.point.y,
              l = Math.sqrt(x * x + y * y),
              r = d.r + quad.point.r;
            if (l < r) {
              l = ((l - r) / l) * (1 + alpha);
              d.x -= x *= l;
              d.y -= y *= l;
              quad.point.x += x;
              quad.point.y += y;
            }
          }
          return x1 > nx2 || x2 < nx1 || y1 > ny2 || y2 < ny1;
        });
      };
    }
    
    const bubbleCloud = (element) => {
      var container = d3.select(".bubble-cloud");
      var $container = $(".bubble-cloud");
      var containerWidth = $container.width();
      var containerHeight = $container.height();
      var svgContainer = container
        .append("svg")
        .attr("width", containerWidth)
        .attr("height", containerHeight);
    
      // prepare layout
      var force = d3.layout
        .force()
        .size([containerWidth, containerHeight])
        .gravity(0)
        .charge(0)
        .friction(1);
      // load data
      force.nodes(data).start();
    
      // create item groups
      var node = svgContainer
        .selectAll(".node")
        .data(data)
        .enter()
        .append("g")
        .attr("class", "node")
        .call(force.drag);
    
      var zoom = d3.behavior
        .zoom()
        .scaleExtent([1, 50])
        .on("zoom", function () {
          var e = d3.event,
            tx = Math.min(
              0,
              Math.max(e.translate[0], containerWidth - containerWidth * e.scale)
            ),
            ty = Math.min(
              0,
              Math.max(e.translate[1], containerHeight - containerHeight * e.scale)
            );
          zoom.translate([tx, ty]);
          node.attr(
            "transform",
            ["translate(" + [tx, ty] + ")", "scale(" + e.scale + ")"].join(" ")
          );
        });
      node.call(zoom);
      // create circles
      var defs = node.append("defs");
    
      function makeFiter(id, color) {
        //make a filter if filter id not present
        if (defs.selectAll("#" + id).empty()) {
          var filter = defs
            .append("filter")
            .attr("id", id)
            .attr("height", "300%")
            .attr("width", "300%")
            .attr("x", "-100%")
            .attr("y", "-100%");
    
          filter
            .append("feGaussianBlur")
            .attr("in", "SourceAlpha")
            .attr("stdDeviation", 10)
            .attr("result", "blur");
    
          filter
            .append("feOffset", 0)
            .attr("in", "blur")
            .attr("result", "offsetBlur");
    
          filter
            .append("feFlood")
            .attr("in", "offsetBlur")
            .attr("flood-color", color)
            .attr("flood-opacity", "1")
    
            .attr("result", "offsetColor");
    
          filter
            .append("feComposite")
            .attr("in", "offsetColor")
            .attr("in2", "offsetBlur")
            .attr("operator", "in")
            .attr("result", "offsetBlur");
    
          var feMerge = filter.append("feMerge");
    
          feMerge.append("feMergeNode").attr("in", "offsetBlur");
          feMerge.append("feMergeNode").attr("in", "SourceGraphic");
        }
        return "url(#" + id + ")"; //return the filter id
      }
    
      function getFilter(d) {
        if (d.color === "red") {
          return makeFiter("fill-text-red", "red");
        } else if (d.color === "green") {
          return makeFiter("fill-text-green", "green");
        }
      }
    
      defs
        .selectAll(null)
        .data(data)
        .enter()
        .append("pattern")
        .attr("id", function (d) {
          return d.image;
        })
        .attr("height", "100%")
        .attr("width", "100%")
        .attr("patternContentUnits", "objectBoundingBox")
        .append("image")
        .attr("height", 1)
        .attr("width", 1)
        .attr("preserveAspectRatio", "none")
        .attr("xlink:href", function (d) {
          return d.image;
        });
    
      node
        .append("circle")
        .attr("r", 1e-6)
        .style("fill", function (d) {
          return "url(#" + d.image + ")";
        })
        .attr("filter", function (d) {
          return getFilter(d);
        })
        .on("mouseover", function (d) {
          d3.select(this)
            .attr("r", 10)
            .style("stroke", "white")
            .style("cursor", "pointer");
        })
        .on("mouseout", function (d) {
          d3.select(this).attr("r", 5.5).style("stroke", "none");
        });
    
      // create labels
      node
        .append("text")
        .text(function (d) {
          return d.text;
        })
        .classed("text", true)
        .style({
          fill: "#141823 ",
          "text-anchor": "middle",
          "font-size": "1vw",
          "font-weight": "bold",
          "text-transform": "uppercase",
          "font-family": "Open Sans, sans-serif",
        });
      //.attr("stroke", "black")
      //.attr("stroke-width", "1px");
    
      node
        .append("text")
        .text(function (d) {
          return d.category;
        })
        .classed("category", true)
        .style("fill", function (d) {
          return d.category.match("-") ? "red" : "green";
        })
        .style({
          "text-anchor": "middle",
          "font-size": "12px",
          "font-weight": "bold",
          "text-transform": "uppercase",
          "font-family": "Open Sans, sans-serif",
        });
    
      // put circle into movement
      force.on("tick", function (e) {
        d3.selectAll("circle")
          .each(collide(0.1))
          .attr("r", function (d) {
            return d.r;
          })
          .attr("cx", function (d) {
            // boundaries
            if (d.x <= d.r) {
              d.x = d.r + 1;
            }
            if (d.x >= containerWidth - d.r) {
              d.x = containerWidth - d.r - 1;
            }
            return d.x;
          })
          .attr("cy", function (d) {
            // boundaries
            if (d.y <= d.r) {
              d.y = d.r + 1;
            }
            if (d.y >= containerHeight - d.r) {
              d.y = containerHeight - d.r - 1;
            }
            return d.y;
          });
    
        d3.selectAll("line").attr({
          x1: function (d) {
            return d.x - d.r + 10;
          },
          y1: function (d) {
            return d.y;
          },
          x2: function (d) {
            return d.x + d.r - 10;
          },
          y2: function (d) {
            return d.y;
          },
        });
    
        d3.selectAll(".text")
          .attr("x", function (d) {
            return d.x;
          })
          .attr("y", function (d) {
            return d.y - 10;
          });
    
        d3.selectAll(".category")
          .attr("x", function (d) {
            return d.x;
          })
          .attr("y", function (d) {
            return d.y + 20;
          });
        force.alpha(0.1);
      });
    };

    if(isLoading){
      return <div className="App">Loading...</div>;
    }

    return ( 
      <div>
        <div className="bubble-cloud" ref={bubbleCloud}></div>
        <table className="styled-table">
        <thead>
          <tr>
            <th>#</th>
            <th>COIN</th>
            <th>NAAM</th>
            <th>PRIJS</th>
            <th>ALL TIME HIGH</th>
            <th>24u</th>
            <th>VOLUME</th>
            <th>MARKT KAPITALISATIE</th>
            <th>TRADE</th>
          </tr>
        </thead>
        <tbody>
          {coins.map((coin) => {
            var refLink =
              "https://www.binance.com/en/trade/" +
              coin.symbol +
              "_USDT?layout=pro&ref=AISWVEO9&type=spot";
            return (
              <tr key={coin.id}>
                <td>{coin.market_cap_rank}</td>
                <td>
                  <img src={coin.image} alt="icon" height="50px"/>
                </td>
                <td>{coin.name}</td>
                <td>${coin.current_price}</td>
                <td>${coin.ath}</td>
                <td>
                  <span className={coin.price_change_percentage_24h > 0 ? "positive" : "negative"}>
                    {Math.round(coin.price_change_percentage_24h * 100) / 100}%
                  </span>
                </td>
                <td>$ {nf.format(coin.total_volume)}</td>
                <td>$ {nf.format(coin.market_cap)}</td>
                <td>
                  <a href={refLink}>
                    <img
                      border="0"
                      alt="Binance"
                      src="https://user-images.githubusercontent.com/12424618/54043975-b6cdb800-4182-11e9-83bd-0cd2eb757c6e.png"
                      width="20"
                      height="20"
                      className="refImg"
                    />
                  </a>
                  <a href="https://bitvavo.com/?a=C2B2E2D724">
                    <img
                      border="0"
                      alt="Bitvavo"
                      src="data:image/png;base64,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"
                      width="20"
                      height="20"
                      className="refImg"
                    />
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      </div>
    );
  }
}






